var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isProductTileEditorial
    ? _c(
        "div",
        {
          staticClass: "rb-product-tile__footer",
          class: {
            "--no-color": !_vm.hasColorsEditorial || _vm.isExplodedTile,
          },
        },
        [
          !_vm.isAddToCart
            ? [
                _vm.hasColorsEditorial && !_vm.isExplodedTile
                  ? [
                      _vm.isLoading
                        ? _c("rb-dummy-skeleton", {
                            staticClass:
                              "rb-product-tile__number-of-colors --number",
                          })
                        : _c(
                            "span",
                            {
                              staticClass:
                                "rb-product-tile__number-of-colors --type",
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.colorsNumberLabel) +
                                  "\n      "
                              ),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoading && !_vm.isPlpExclusive
                  ? _c(
                      "div",
                      { staticClass: "--skeleton-wrapper" },
                      [
                        _vm.isLoading
                          ? _c("rb-dummy-skeleton", {
                              staticClass: "rb-product-tile__customize --icon",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLoading
                          ? _c("rb-dummy-skeleton", {
                              staticClass: "rb-product-tile__customize --text",
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedVariant.customizable &&
                !_vm.isLoading &&
                !_vm.isPlpExclusive
                  ? _c(
                      "button",
                      {
                        staticClass: "rb-product-tile__customize --no-click",
                        attrs: {
                          tabindex: _vm.customizeIconTabIndex,
                          "data-description": _vm.dataDescriptionCustomize,
                          "data-element-id": _vm.TILES_CUSTOMIZE,
                          "data-href": _vm.selectedVariant.customizable,
                        },
                      },
                      [
                        _c("rb-lazy-icon", {
                          attrs: { icon: "customize-plp" },
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.product_tile.customize")) +
                            "\n    "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _c(
                "button",
                {
                  staticClass: "rb-btn rb-btn--red --no-click",
                  attrs: {
                    "data-element-id": _vm.addToBagDataElementId,
                    "data-description": _vm.dataDescriptionCustomize,
                  },
                  on: { click: _vm.addToBag },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("common.product_tile.add_to_bag")) +
                      "\n  "
                  ),
                ]
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }